(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ModelMeter', ModelMeter);

    ModelMeter.$inject = ['$resource'];

    function ModelMeter ($resource) {
        var resourceUrl =  'api/model-meters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
